import React from 'react'
import folderClosed from '../../images/folderClosed.svg'
import moment from 'moment'
import PropTypes from 'prop-types'
import NamePlate from './NamePlate'

const Folder = (props: any) => {
  const { folderData, selectFolder, openFolder } = props
  const { id, folderName: name, date, isSelected } = folderData
  return (
    <div className="folder-parent-wrapper">
      <div
        className="folder-wrapper"
        style={isSelected ? { background: '#edebe9' } : {}}
        key={id}
        onClick={openFolder.bind(null, folderData)}
      >
        <div className="image">
          <img src={folderClosed} alt="name" />
        </div>
        <NamePlate name={name} date={moment(date, 'DD/MM/YYYY').format('DD/MM/YYYY')} />
      </div>
      <div className="f-selector">
        <input
          type="checkbox"
          checked={isSelected}
          onChange={selectFolder.bind(null, folderData)}
        />
      </div>
    </div>
  )
}

Folder.propTypes = {
  selectFolder: PropTypes.func,
  openFolder: PropTypes.func,
  folderData: PropTypes.object,
}

Folder.defaultProps = {
  folderData: {
    id: '',
    name: 'First Folder',
    date: moment(),
    isSelected: false,
  },
  selectFolder: () => {},
  openFolder: () => {},
}

export default Folder
